<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <div class="users-table-container">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [getContextMenuItems]="getContextMenuItems"
      [getMainMenuItems]="getMainMenuItems"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      (columnMoved)="onColumnMoved($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (sortChanged)="onSortChange($event)"
      [getRowId]="getRowId"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [message]="messageForModal" [dialogRef]="dialogRef"></deletemodal>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Comment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <textarea class="form-control comment" [formControl]="commentTextFormControl"></textarea>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="onCommentSave()" [disabled]="loading">Save</button>
    </div>
  </div>
</ng-template>

<ng-template #balanceAdjustmentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Adjust balance</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  @if (currentRow) {
    <div class="modal-body">
      <form [formGroup]="balanceAdjustmentForm">
        <div class="mb-15">
          <div class="d-flex justify-content-between mb-5">
            <span>User</span>
            <strong>{{ currentRow.email }}</strong>
          </div>
          <div class="d-flex justify-content-between mb-5">
            <span>Current balance</span>
            <strong>{{ currentRow.balance | currency: 'EUR' : 'symbol' : '1.2-2' }}</strong>
          </div>
          <div class="d-flex justify-content-between">
            <span>New balance</span>
            <strong>{{ getBalanceAdjustmentResult() | currency: 'EUR' : 'symbol' : '1.2-2' }}</strong>
          </div>
        </div>

        <div class="form-group mb-15">
          <label class="form-label">Action</label>
          <div class="d-flex gap-15">
            <label class="form-check">
              <input class="form-check-input" type="radio" formControlName="operation" value="ADJUST" />
              <span class="form-check-label">Adjust amount</span>
            </label>
            <label class="form-check">
              <input class="form-check-input" type="radio" formControlName="operation" value="SET_TO_ZERO" />
              <span class="form-check-label">Set to zero</span>
            </label>
          </div>
        </div>

        <div class="form-group mb-0" *ngIf="balanceAdjustmentForm.value.operation === 'ADJUST'">
          <label class="form-label required">Amount (EUR)</label>
          <input formControlName="amountEuro" type="number" step="0.001" class="form-control" />
          <small class="text-neutral-n6">Use a negative value to deduct balance. Minimum effective adjustment is €0.001.</small>
        </div>
      </form>
    </div>
  }

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="onBalanceAdjustmentSave()" [disabled]="loading || isBalanceAdjustmentInvalid()">Save</button>
    </div>
  </div>
</ng-template>
